import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { adminApi, SetMemberActiveResponse } from 'services/adminApi';

interface SetMemberActiveRequest {
  companyId: string;
  userId: string;
  /** false = archive (soft, reversible), true = reactivate. */
  active: boolean;
}

/**
 * Archive or reactivate a company member (VERA-816). Soft + reversible —
 * distinct from useRemoveMember (hard delete).
 */
export const useSetMemberActive = (
  options?: UseMutationOptions<SetMemberActiveResponse, Error, SetMemberActiveRequest>
) => {
  return useMutation<SetMemberActiveResponse, Error, SetMemberActiveRequest>({
    mutationFn: ({ companyId, userId, active }: SetMemberActiveRequest) =>
      adminApi.setMemberActive(companyId, userId, active),
    ...options,
  });
};
